import { render, staticRenderFns } from "./indexshop.vue?vue&type=template&id=71bd56e0"
import script from "./indexshop.vue?vue&type=script&lang=js"
export * from "./indexshop.vue?vue&type=script&lang=js"
import style0 from "./indexshop.vue?vue&type=style&index=0&id=71bd56e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports